import axios from '@/utils/request';

export default {
  /**
   * 新增系统参数
   * @param {Object} data
   */
  addConfig(data) {
    return axios({
      url: '/api/v1/sysConfig/add',
      method: 'POST',
      data,
    });
  },
  /**
   * 编辑系统参数
   */
  editConfig(data) {
    return axios({
      url: '/api/v1/sysConfig/update',
      method: 'POST',
      data,
    });
  },
  /**
   * 删除系统参数
   * @param {Object} params
   * @returns Promise
   */
  deleteConfig(params) {
    return axios({
      url: '/api/v1/sysConfig/delete',
      method: 'POST',
      params,
    });
  },
  /**
   * 获取参数适用范围
   * @param {Object} data
   * @returns Promise
   */
  searchRange(data) {
    return axios({
      url: '/api/v1/sysConfig/range/list',
      method: 'POST',
      data,
    });
  },
  /**
   * 分页查询系统参数配置
   * @param {Object} params
   * @returns Promise
  */
  getConfig(params) {
    return axios({
      url: '/api/v1/sysConfig/page',
      method: 'GET',
      params,
    });
  },

  /**
   * 分页查询系统参数配置
   * @param {Object} params
   * @returns Promise
  */
  getConfigWithoutToken(params) {
    return axios({
      url: '/api/v1/sysConfig/pageWithoutToken',
      method: 'GET',
      params,
    });
  },
};
